"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const searchCountriesUseCase_1 = __importDefault(require("@/useCases/countries/searchCountriesUseCase"));
const listPortsUseCase_1 = __importDefault(require("@/useCases/ports/listPortsUseCase"));
const selectors_1 = require("@/store/ducks/countries/selectors");
const index_view_1 = __importDefault(require("./index.view"));
function ListPortsSection() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const shouldShowPortsTable = (0, react_redux_1.useSelector)(selectors_1.selectedCountryIdSelector);
    react_1.default.useEffect(() => {
        (0, searchCountriesUseCase_1.default)()(dispatch);
        (0, listPortsUseCase_1.default)()(dispatch);
    }, []);
    return react_1.default.createElement(index_view_1.default, { shouldShowPortsTable: Boolean(shouldShowPortsTable) });
}
exports.default = ListPortsSection;
